import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { DEFAULT_QUALIFICATION_CATEGORIES } from "./constants";

export function useGetQualificationCategoriesConfig() {
  return useCbhFlag(CbhFeatureFlag.QUALIFICATION_CATEGORIES_CONFIG, {
    defaultValue: DEFAULT_QUALIFICATION_CATEGORIES,
  });
}
